module.exports = __webpack_public_path__ + "static/img/award.f952086.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/match/award.png
// module id = EWhq
// module chunks = 0